import { useState } from "react";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { startCheckout } from "@/lib/checkout";

export const BuyButton = ({ label, className = "", testId, small = false }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    await startCheckout();
    setBusy(false);
  };
  return (
    <button onClick={go} disabled={busy} data-testid={testId}
      className={`btn-ink group inline-flex items-center gap-3 rounded-full font-semibold disabled:opacity-70 ${small ? "px-4 py-2 text-sm" : "px-7 py-4 text-base"} ${className}`}>
      {label}
      <span className={`flex items-center justify-center rounded-full bg-[var(--sage)] text-[var(--ink)] transition-transform duration-300 group-hover:rotate-45 ${small ? "h-5 w-5" : "h-7 w-7"}`}>
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ArrowUpRight className="h-3.5 w-3.5" />}
      </span>
    </button>
  );
};
